import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

import { UrlService } from '@service/url/url.service';
import { RestService, TruckLane } from 'cargo-chief-commons';
import { UtilService } from '@service/util/util.service';
import { SNACKBAR } from '@domain/constants/snackbar-setting';
import { CarrierEquipmentDataService } from '../../admin/carrier-equipment/carrier-equipment-data.service';
import { finalize } from 'rxjs/operators';
import { Equipment } from '../../admin/carrier-equipment/equipment';

@Component({
	selector: 'app-lane-actions',
	templateUrl: './lane-actions.component.html',
	styleUrls: ['./lane-actions.component.scss'],
})
export class LaneActionsComponent implements OnInit {
	@Input() lanesList = null;
	@Input() carrierid;
	@Input() carrier;
	@Input() contactList;
	@Input() lane;
	@Input() isLaneUpdating: boolean;
	@Input() inputConfig: any = {
		origin: false,
		trailerType: false,
		destination: false,
	};
	@Input() enableProjectSearch: boolean = false;

	@Output() lanesListUpdated: EventEmitter<any> = new EventEmitter();
	@Output() isLaneUpdatingChange = new EventEmitter<boolean>();

	constructor(
		public utilService: UtilService,
		private urlService: UrlService,
		private restService: RestService,
		private carrierEquipmentService: CarrierEquipmentDataService,
		private router: Router
	) {}

	ngOnInit() {}

	laneUpdated(updatedLane) {
		var updatedIndex;
		this.lanesList.map((lane, index) => {
			if (lane.id == updatedLane.id) {
				updatedIndex = index;
			}
		})[0];
		this.lanesList[updatedIndex] = updatedLane;
		this.emitUpdatedLanesList();
	}

	refreshLane(id: string) {
		let indexOfUpdatedLane: number;
		this.isLaneUpdatingChange.emit(true);
		this.lanesList.filter((lane, index) => {
			if (lane.id === id) {
				indexOfUpdatedLane = index;
				return true;
			}
		});
		const url = this.urlService.refreshLane();
		this.restService.POST(url, { id }).subscribe(
			(result) => {
				this.lanesList[indexOfUpdatedLane] = result.data;
				this.utilService.showSnackbar(result.message, SNACKBAR.SUCCESS, SNACKBAR.ACTION);
				this.isLaneUpdatingChange.emit(false);
				this.emitUpdatedLanesList();
			},
			(error) => {
				this.isLaneUpdatingChange.emit(false);
				this.utilService.showSnackbar(
					'Unable to refresh lane. Please try again later.',
					SNACKBAR.ERROR,
					SNACKBAR.ACTION
				);
			}
		);
	}

	removeLane(id: string) {
		this.isLaneUpdatingChange.emit(true);
		const url = this.urlService.removeLane();
		this.restService
			.POST(url, { id: id })
			.pipe(
				finalize(() => {
					this.removeEquipmentForCarrier(this.carrierid, this.lane);
				})
			)
			.subscribe(
				(result) => {
					this.isLaneUpdatingChange.emit(false);
					this.deleteLane(id);
				},
				(error) => {
					if ((error.status = 200)) {
						this.deleteLane(id);
					} else {
						this.utilService.showSnackbar(
							'Unable to delete lane. Please try again later.',
							SNACKBAR.ERROR,
							SNACKBAR.ACTION
						);
					}
					this.isLaneUpdatingChange.emit(false);
				}
			);
	}

	deleteLane(id: string) {
		this.lanesList = this.lanesList.filter((lane) => {
			if (id != lane.id) {
				return lane;
			}
		});
		this.utilService.showSnackbar(
			'Truck Lane deleted successfully.',
			SNACKBAR.SUCCESS,
			SNACKBAR.ACTION
		);
		this.emitUpdatedLanesList();
	}

	emitUpdatedLanesList() {
		this.lanesListUpdated.emit(this.lanesList);
		this.carrierEquipmentService.pushLaneCount(this.lanesList.length);
	}

	removeEquipmentForCarrier(carrierId: string, lane: any) {
		const equipment = this.carrierEquipmentService.mapTrailerTypeToEquipment(lane.trailerType);
		if (!this.utilService.isNullOrUndefined(equipment)) {
			this.carrierEquipmentService
				.deleteEquipmentForCarrier(carrierId, equipment.id)
				.then((results) => {
					if (!this.isEquipmentInLaneList(equipment)) {
						this.carrierEquipmentService.equipmentList =
							this.carrierEquipmentService.equipmentList.filter((e) => {
								return e.id !== equipment.id;
							});
						this.carrierEquipmentService.push(this.carrierEquipmentService.equipmentList);
					}
				})
				.catch((error) => {
					const msg = error['error'] || 'Unable to remove equipment for carrier.';
					this.utilService.showSnackbar(msg, SNACKBAR.ERROR, SNACKBAR.ACTION);
				});
		}
	}

	isEquipmentInLaneList(equipment: Equipment) {
		let count = 0;
		this.lanesList.forEach((lane) => {
			const laneEquipment = this.carrierEquipmentService.mapTrailerTypeToEquipment(
				lane.trailerType
			);
			if (!this.utilService.isNullOrUndefined(laneEquipment)) {
				if (laneEquipment.id === equipment.id) {
					count++;
				}
			}
		});
		return count !== 0;
	}

	navigateToProjectsBoard(): void {
		const lane: TruckLane = this.lanesList.find((truckLane) => this.lane.id === truckLane.id);
		if (!lane) {
			return;
		}
		const filters: any = {
				origin: {
					city: lane.originCity,
					state: lane.originState,
					latitude: lane.originLat,
					longitude: lane.originLng,
				},
				destination: {
					city: lane.destCity,
					state: lane.destState,
					latitude: lane.destLat,
					longitude: lane.destLng,
				},
				equipmentTypes: [lane.trailerType],
			},
			params: any = {
				filter: JSON.stringify(filters),
			},
			page = 0;
		this.router.navigate([`carriers/projects_board`], {
			queryParams: {
				...params,
				page,
			},
		});
	}
}
